import FetchWrapper from "../../../../Network/FetchWrapper";
import {CommonResponseDTO, CommonResponseJSON} from "../../../../Network/CommonResponse";
import {SimpleSignboard, SimpleSignboardDTO} from "../DTO/SimpleSignboardDTO";
import {withAdminsAuth} from "../../../../Network/BrowserFetchWrapper";
import {SignboardRepo} from "./SignboardRepo";
import {Signboard, SignboardDTO} from "../DTO/SignboardDTO";
import {DTO} from "../../../../Common/DtoUtilities";
import {MBAdminError} from "../../../Utils/MBAdminError";

class NetworkSignboardRepo implements SignboardRepo {
  private fetchWrapper: FetchWrapper
  private serverUrl = process.env.REACT_APP_MEMBUCKET_ADMIN_APP_SERVER_URL

  constructor(fetchWrapper: FetchWrapper) {
    this.fetchWrapper = fetchWrapper
  }

  create(signboard: SignboardDTO): Promise<CommonResponseDTO<number>> {
    return this.fetchWrapper.postJson(
      `${this.serverUrl}/v1/a/r/signboards`,
      DTO.toObject(signboard),
      withAdminsAuth()
    ).then((response: CommonResponseJSON<number>) => {
      return CommonResponseDTO.from(
        response,
        (json: number) => json,
      )
    })
  }

  update(signboard: SignboardDTO): Promise<CommonResponseDTO<null>> {
    if (signboard.signboardId === null) throw new MBAdminError('signboardId is null')

    return this.fetchWrapper.putJson(
      `${this.serverUrl}/v1/a/r/signboards/${signboard.signboardId}`,
      DTO.toObject(signboard),
      withAdminsAuth()
    ).then((response: CommonResponseJSON<null>) => {
      return CommonResponseDTO.from(
        response,
        (json: null) => json,
      )
    })
  }

  delete(signboardId: number): Promise<CommonResponseDTO<null>> {
    return this.fetchWrapper.deleteJson(
      `${this.serverUrl}/v1/a/r/signboards/${signboardId}`,
      withAdminsAuth()
    ).then((response: CommonResponseJSON<null>) => {
      return CommonResponseDTO.from(
        response,
        (json: null) => json,
      )
    })
  }

  getList(): Promise<CommonResponseDTO<SimpleSignboardDTO[]>> {
    return this.fetchWrapper.getByJson(`${this.serverUrl}/v1/a/r/signboards`, withAdminsAuth())
      .then((response: CommonResponseJSON<SimpleSignboard[]>) => {
        return CommonResponseDTO.fromArray(
          response,
          SimpleSignboardDTO.fromJSON,
        )
      })
  }

  getById(signboardId: number): Promise<CommonResponseDTO<SignboardDTO>> {
    return this.fetchWrapper.getByJson(`${this.serverUrl}/v1/a/r/signboards/${signboardId}`, withAdminsAuth())
      .then((response: CommonResponseJSON<Signboard>) => {
        return CommonResponseDTO.from(
          response,
          SignboardDTO.fromJSON,
        )
      })
  }

}

export default NetworkSignboardRepo
